<div class="horizontal-scroll-menu">
  <div #scrollContainer class="scroll-container">
    <ul class="list">
      <ng-template [ngIf]="type === 'link'">
        <li *ngFor="let item of scrollList; trackBy: trackByFn" class="list-item">
          <a class="list-item-label"
             [routerLink]="item.route"
             routerLinkActive="selected">
            {{ item.title | customLocale }}
          </a>
          <ng-template [ngIf]="item?.native">
            <span class="native">{{ 'teacher-card.native' | customLocale }}</span>
          </ng-template>
        </li>
      </ng-template>
      <ng-template [ngIf]="type === 'text'">
        <li *ngFor="let item of scrollList; trackBy: trackByFn"
            (click)="selectOption(item)"
            class="list-item">
            <span class="list-item-label"
                  [class.selected]="isSelected(item)">
              {{ item.title | customLocale }}
            </span>
          <ng-template [ngIf]="item?.native">
              <span class="native">
                {{ 'teacher-card.native' | customLocale }}
              </span>
          </ng-template>
        </li>
      </ng-template>
    </ul>
  </div>
</div>
